import React from "react";
import type {FunctionComponent} from "react";
import {useWhenLessonNotInUserLibraryLogic} from "./WhenLessonNotInUserLibrary.logic";

export interface IWhenLessonNotInUserLibraryProps {
  lessonID: number;
}

export const WhenLessonNotInUserLibrary: FunctionComponent<IWhenLessonNotInUserLibraryProps> = ({lessonID, children}) => {
  const {isLessonInUserLibrary} = useWhenLessonNotInUserLibraryLogic(lessonID);
  if (isLessonInUserLibrary){
    // not in user library
    return null;
  }
  return <>{children}</>;
}

